import { render, staticRenderFns } from "./lectureDetail_video.vue?vue&type=template&id=296facf2&scoped=true&"
import script from "./lectureDetail_video.vue?vue&type=script&lang=js&"
export * from "./lectureDetail_video.vue?vue&type=script&lang=js&"
import style0 from "./lectureDetail_video.vue?vue&type=style&index=0&id=296facf2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "296facf2",
  null
  
)

export default component.exports